import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import FlexColumn from '../../../../components/molecules/FlexColumn'
import OpalHeading from '../../../../components/opal/OpalHeading'
import ReadingListMenuItem from './ReadingListMenuItem'

function ReadingListMain ({ readingList }) {
  const history = useHistory()

  // If only one item exists, redirect to it
  useEffect(() => {
    if (readingList.unread?.length === 1) {
      const singleItem = readingList.unread[0]
      history.replace(`/denali-ai/reading-list/item/${singleItem.scheduleId}`)
    }
  }, [readingList.unread, history])

  // Show empty state if no items
  const totalCount = readingList.digestCount + readingList.promptCount
  if (totalCount === 0) {
    return (
      <FlexColumn className='gap-md items-center justify-center' style={{ minHeight: '200px' }}>
        <div className='font-serif font-size-lg' style={{ color: 'var(--color-neutral-400)' }}>
          Your reading list is empty
        </div>
        <div className='font-serif font-size-sm' style={{ color: 'var(--color-neutral-500)' }}>
          New scheduled insights will appear here when they're ready
        </div>
      </FlexColumn>
    )
  }

  return (
    <FlexColumn className='gap-xl font-serif'>
      {readingList.digestCount ? (
        <FlexColumn className='gap-md'>
          <OpalHeading className='font-size-sm'>Digests</OpalHeading>
          {readingList.digests.map(item => (
            <ReadingListMenuItem scheduledPrompt={item} key={item.scheduleId} />
          ))}
        </FlexColumn>
      ) : null}
      {readingList.promptCount ? (
        <FlexColumn className='gap-md'>
          <OpalHeading className='font-size-sm'>Scheduled Prompts</OpalHeading>
          {readingList.prompts.map(item => (
            <ReadingListMenuItem scheduledPrompt={item} key={item.scheduleId} />
          ))}
        </FlexColumn>
      ) : null}
    </FlexColumn>
  )
}

ReadingListMain.propTypes = {
  readingList: PropTypes.object.isRequired
}

export default ReadingListMain
